module.exports = __webpack_public_path__ + "img/post-role.153bda9.svg";